import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const CaretDownIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M5.99977 9.00005L11.9998 15L17.9998 9" stroke="currentColor" strokeMiterlimit="16" />
    </SvgIcon>
  )
}
